import {
  ACTION_LOAD_POSTBACK_SETTINGS__REQUEST,
  ACTION_LOAD_POSTBACK_SETTINGS__SUCCESS,
  ACTION_LOAD_POSTBACK_SETTINGS__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_LOAD_POSTBACK_SETTINGS__REQUEST:
    case ACTION_LOAD_POSTBACK_SETTINGS__SUCCESS:
      return null;

    case ACTION_LOAD_POSTBACK_SETTINGS__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
